import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { motion, AnimatePresence } from "framer-motion";

import { SimpleTextPage } from "./SurveyScreens";
import { SurveyOptionContainer, SurveyOptionButton } from "./SurveyComponents";
import { useApplication } from "../../contexts/ApplicationContext";


export default function ScreenOne() {
  const [isTypingDone, setIsTypingDone] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const navigate = useNavigate();
  const typingSpeed = 85;
  const isMdOrLarger = useMediaQuery({ minWidth: 768 });
  
  const { formData, updateFormData } = useApplication();

  useEffect(() => {
    let uniqueId = sessionStorage.getItem("unique_id");

    if (!uniqueId) {
      uniqueId = uuidv4();
      sessionStorage.setItem("unique_id", uniqueId); // ✅ Store in sessionStorage
    }

    const referralCode = sessionStorage.getItem("referral_code") || "";

    // Store values in context for persistence across screens
    updateFormData("uniqueId", uniqueId);
    updateFormData("referral_code", referralCode);

    // Use sendBeacon if supported for better reliability
    const formData = new FormData();
    formData.append("unique_id", uniqueId);
    formData.append("referral_code", referralCode);
    const BASE_URL = process.env.REACT_APP_API_URL
    navigator.sendBeacon(`${BASE_URL}/api/track-application/`, formData);

  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = "black";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const handleTypingDone = () => {
    setIsTypingDone(true);
  };

  const handleYes = () => {
    setIsFadingOut(true);

    // Track
    let uniqueId = sessionStorage.getItem("unique_id");

    if (!uniqueId) {
      uniqueId = uuidv4();
      sessionStorage.setItem("unique_id", uniqueId);
    }

    // Use sendBeacon if supported for better reliability
    const data = new FormData();
    data.append("unique_id", uniqueId);
    data.append("screen1", "Berkeley");
    const BASE_URL = process.env.REACT_APP_API_URL
    navigator.sendBeacon(`${BASE_URL}/api/track-application/`, data);

    setTimeout(() => navigate("/berkeley/application/2"), 600); // Wait for animation before navigating
  };

  const handleNo = () => {
    setIsFadingOut(true);

    // Track
    let uniqueId = sessionStorage.getItem("unique_id");

    if (!uniqueId) {
      uniqueId = uuidv4();
      sessionStorage.setItem("unique_id", uniqueId);
    }

    // Use sendBeacon if supported for better reliability
    const data = new FormData();
    data.append("unique_id", uniqueId);
    data.append("screen1", "NOT Berkeley");
    const BASE_URL = process.env.REACT_APP_API_URL
    navigator.sendBeacon(`${BASE_URL}/api/track-application/`, data);

    setTimeout(() => window.location.href = 'https://prospinity.com', 600); // Wait for animation before navigating
  };

  const firstPageText = [
    {
        sequences: [
          { content: 800, wrapper: "span", style: {} },  // Extra spacing before this line
          { content: "Welcome to ", wrapper: "span", style: {} },
          { content: "Prospinity@Berkeley…", wrapper: "strong", style: {} }, // Italicized text
        ],
    },
    {
        sequences: [
          { content: 800, wrapper: "span", style: {} },  // Extra spacing before this line
          { content: "Just to confirm, are you a Berkeley student?", wrapper: "span", style: { display: "block", marginTop: "2rem" } }, // Italicized text
          { content: 500, wrapper: "span", style: {} },
        ],
    }
  ];
  
  return (
    <AnimatePresence>
      {!isFadingOut && (
        <motion.div
          key="screen-one"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }} // Smooth fade-out
          transition={{ duration: 0.6, ease: "easeOut" }} // Smooth easing
          style={{ width: "80%" }}
        >
          {/* Text content */}
          <SimpleTextPage
            paragraphs={firstPageText}
            typing={true}
            typingSpeed={typingSpeed}
            onTypingDone={handleTypingDone} // Ensures we track typing completion
          />
  
          {/* Buttons (only appear after typing is done) */}
          {isTypingDone && (
            <motion.div
              key="buttons"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 0 }} // Ensure buttons fade with text
              transition={{ duration: 0.6 }}
              style={{ width: "100%" }}
            >
              <SurveyOptionContainer isMdOrLarger={isMdOrLarger}>
                <SurveyOptionButton
                  key="YES"
                  onClick={handleYes}
                  isMdOrLarger={isMdOrLarger}
                >
                  {"YES"}
                </SurveyOptionButton>
                <SurveyOptionButton
                  key="NO"
                  onClick={handleNo}
                  isMdOrLarger={isMdOrLarger}
                >
                  {"NO"}
                </SurveyOptionButton>
              </SurveyOptionContainer>
            </motion.div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}  
